/** @format */

import React from 'react';
import { Input } from 'antd';

export default function CustomSearch(props) {
	return <Input.Search {...props} />;
}
